import { DataSourceMode } from "@mcleod/components";
import { AutogenLayoutAddMenuBranch } from "./autogen/AutogenLayoutAddMenuBranch";
import { DatabaseMenuItem } from "./DatabaseMenuItem";
import { MenuEditorTreeNode } from "./MenuEditorTreeNode";
import { MenuEditorUtil } from "./MenuEditorUtil";
import { EditMenuItemResult, MenuItemEditor } from "./MenuItemEditor";
import { RowWebMenuGroupType } from "../models/ModelWebMenuGroup";

export class AddMenuBranch extends AutogenLayoutAddMenuBranch {

    public get branchLayout(): MenuItemEditor {
        return this.layoutBranch as MenuItemEditor;
    }

    public get leafLayout(): MenuItemEditor {
        return this.layoutLeaf as MenuItemEditor;
    }

    async configureForAddMode(parentNodes: MenuEditorTreeNode[]) {
        const parentItem = await DatabaseMenuItem.createNewMenuItem();
        const childLeaf = await DatabaseMenuItem.createNewMenuItem();
        parentItem.addChild(childLeaf);
        this.branchLayout.setMenuItemAndMode(parentItem, DataSourceMode.ADD);
        this.leafLayout.setMenuItemAndMode(childLeaf, DataSourceMode.ADD);
        this.showReferences("The new submenu will be added to", parentNodes);
    }


    showReferences(msg: string, references: MenuEditorTreeNode[]) {
        this.panelItem.fillHeight = true;
        MenuEditorUtil.addReferencePanel({text: msg, fontSize: "large"}, references, this);
    }

    getNewBranchMenuItem(): EditMenuItemResult {
        const childMenuItem = this.leafLayout.getEditMenuItemResult().menuItem;
        childMenuItem.groupData.set("group_type", RowWebMenuGroupType.LEAF);
        const branchResult = this.branchLayout.getEditMenuItemResult();
        const branchMenuItem = branchResult.menuItem;
        branchMenuItem.groupData.set("group_type", RowWebMenuGroupType.BRANCH);
        branchMenuItem.items = [childMenuItem];
        return branchResult;
    }
}
